import React from 'react'
import '../styles/Home.css'

function Home() {
    return (
        <div className="container">
        <div className="header d-flex justify-content-between">
            {/* <h1 className="title mt-2">tas's Web</h1> */}
            <span className="mt-4 fs-3 dark toggle"><i className="fas fa-moon d-none" id="dark" title="Switch to Dark Mode"></i></span>          
            <span className="mt-4 fs-3 light toggle" id="light"><i className="fas fa-sun" title="Switch to Light Mode"></i></span>          
        </div>
        <center>
            <div className="main">
                <div className="">
                    <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_1280.png" className="tas mt-2 rounded-circle" alt="CA Tarak A Shah" />
                    <div className="card-body">
                        <h1 className="card-title">
                            CA Tarak Shah
                        </h1>
                        <p className="info">
                        Practicing Chartered Accountant and Fellow Member of Institute of Chartered Accountants of India (ICAI). Academically apart from Chartered Accountancy, awarded a degree of Master of Commerce (M. Com) and Diploma in Taxation Laws and Practice and DISA. Professionally, having 16 years of rich Corporate experience including MNCs. Practicing in the field of Audit, Income-Tax, ROC, Valuation, Data analysis and Data Mining Areas. Expertise in the field of GST consultancy. Rich experience of Statutory Bank Audit of Co.op Banks and as a Associate, Audit of statutory Audit of PSU Banks. Certified Forensic Auditor as Certificate awarded by ICAI (New Delhi ) for Forensic Accounting and Fraud Prevention (FAFP) and Certified Concurrent Audit of Bank (ICAI).
                        </p>
                        <a href="/appointment">
                        <button className="btn btn-dark">Take Appointment</button>
                        </a>
                    </div>
                </div>
            </div>
        </center>
    </div>
    )
}

export default Home
